import React from 'react';

const Location = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="23" viewBox="0 0 17 23">
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero" stroke="#141414">
        <g>
          <g>
            <g>
              <path
                d="M16.34 8.564c.05-4.01-2.936-7.41-6.92-7.877C5.439.221 1.748 2.838.87 6.751c-.484 2.03-.159 4.169.906 5.963l5.22 8.755c.315.53.886.857 1.504.857s1.19-.326 1.504-.857l5.211-8.764c.744-1.253 1.132-2.684 1.124-4.141zM5.607 9.73c-.682-1.274-.45-2.845.572-3.867 1.023-1.023 2.594-1.255 3.868-.573 1.275.682 1.953 2.118 1.67 3.536-.263 1.297-1.277 2.311-2.575 2.573-1.417.284-2.853-.394-3.535-1.669z"
                transform="translate(-120 -3615) translate(0 2932) translate(114 320) translate(0 360) translate(6 3)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Location;
